"use client";

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@aio/platform-ui";
import { useRegisterShortcut } from "@aio/platform-keyboard";

export default function KeyboardShowcase() {
  useRegisterShortcut({ id: "showcase:demo-1", keys: "g a", scope: "global", label: "Go to accounting" });
  useRegisterShortcut({ id: "showcase:demo-2", keys: "/", scope: "global", label: "Focus search" });
  useRegisterShortcut({ id: "showcase:demo-3", keys: "Cmd+K", scope: "global", label: "Open command palette" });
  useRegisterShortcut({ id: "showcase:demo-4", keys: "n", scope: "list", label: "New item" });
  useRegisterShortcut({ id: "showcase:demo-5", keys: "?", scope: "global", label: "Show shortcuts" });

  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">Keyboard</h1>
        <p className="mt-1 text-fg-muted">
          Press <kbd className="rounded border border-border bg-bg-subtle px-1.5 py-0.5 font-mono text-xs">?</kbd> to
          open the help overlay.
        </p>
      </header>
      <Card>
        <CardHeader>
          <CardTitle as="h2">Registered on this page</CardTitle>
          <CardDescription>
            Five shortcuts have been registered. Open the help overlay (?) to see them.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <ul className="space-y-1 text-sm">
            <li>
              <kbd className="rounded border border-border bg-bg-subtle px-1.5 py-0.5 font-mono text-xs">g a</kbd> — Go
              to accounting
            </li>
            <li>
              <kbd className="rounded border border-border bg-bg-subtle px-1.5 py-0.5 font-mono text-xs">/</kbd> —
              Focus search
            </li>
            <li>
              <kbd className="rounded border border-border bg-bg-subtle px-1.5 py-0.5 font-mono text-xs">Cmd K</kbd> —
              Open command palette
            </li>
            <li>
              <kbd className="rounded border border-border bg-bg-subtle px-1.5 py-0.5 font-mono text-xs">n</kbd> — New
              item
            </li>
          </ul>
        </CardContent>
      </Card>
    </div>
  );
}
